import { motion } from "framer-motion";

const SRC = ["/img/chunk_watermelon.webp", "/img/chunk_pineapple.webp", "/img/chunk_watermelon.webp", "/img/ring_pineapple.webp"];
const rand = (i, s) => {
  const x = Math.sin(i * 9301 + s * 49297) * 233280;
  return x - Math.floor(x);
};

const PIECES = Array.from({ length: 26 }, (_, i) => {
  const a = (i / 26) * Math.PI * 2 + rand(i, 1) * 0.5;
  const d = 28 + rand(i, 2) * 40;
  return {
    src: SRC[i % 4],
    size: (50 + rand(i, 3) * 90) * (i % 2 === 0 ? 1.6 : 1),
    x: Math.cos(a) * d,
    y: Math.sin(a) * d * 0.8,
    rot: (rand(i, 4) - 0.5) * 720,
    delay: rand(i, 5) * 0.12,
  };
});

export const Explosion = () => (
  <div className="pointer-events-none fixed inset-0 z-40 overflow-hidden" aria-hidden="true">
    <motion.div
      className="absolute left-1/2 top-1/2 w-40 h-40 -ml-20 -mt-20 rounded-full bg-[#FFF4D6]"
      initial={{ scale: 0, opacity: 0.6 }}
      animate={{ scale: 14, opacity: 0 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
    />
    <motion.div
      className="absolute left-1/2 top-1/2 w-40 h-40 -ml-20 -mt-20 rounded-full border-[6px] border-[#E6194B]"
      initial={{ scale: 0, opacity: 1 }}
      animate={{ scale: 9, opacity: 0 }}
      transition={{ duration: 1.1, delay: 0.05, ease: "easeOut" }}
    />
    {PIECES.map((p, i) => (
      <motion.img
        key={i}
        src={p.src}
        alt=""
        className="absolute drop-shadow-[0_12px_18px_rgba(24,18,3,0.35)]"
        style={{ width: `var(--w)`, left: "calc(50% - var(--w) / 2)", top: "calc(50% - var(--w) / 2)", "--w": `clamp(40px, ${(p.size / 13).toFixed(2)}vw, ${Math.round(p.size)}px)` }}
        initial={{ x: 0, y: 0, scale: 0.1, rotate: 0, opacity: 0 }}
        animate={{
          x: [0, `${p.x}vw`, `${p.x * 1.1}vw`, `${p.x * 1.15}vw`],
          y: ["0vh", `${p.y}vh`, `${p.y + 25}vh`, `${p.y + 70}vh`],
          scale: [0.1, 1.1, 1, 0.9],
          rotate: [0, p.rot * 0.6, p.rot * 0.8, p.rot],
          opacity: [0, 1, 1, 0],
        }}
        transition={{ duration: 2.2, delay: p.delay, times: [0, 0.3, 0.7, 1], ease: "easeOut" }}
      />
    ))}
  </div>
);
